import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

export interface HeadProps {
  children?: ReactNode;
}

export default function Head({ children }: HeadProps) {
  return <Helmet>{children}</Helmet>;
}
